import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import CheckoutNotFound from '@/components/checkout/CheckoutNotFound';
import CheckoutLoader from '@/components/checkout/CheckoutLoader';
import { PostPurchaseDownloadHandler } from '@/components/sequences/PostPurchaseDownloadHandler';
import DownloadFlowAuthModal from '@/components/download/DownloadFlowAuthModal';
import { usePurchaseDetails } from '@/hooks/usePurchaseDetails';

const PurchaseSuccess: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { purchase, isLoading } = usePurchaseDetails(id);
  const [downloadCompleted, setDownloadCompleted] = useState(false);

  const handleDownloadComplete = () => {
    setDownloadCompleted(true);
  };

  const handleError = (error: string) => {
    console.error('Purchase success page error:', error);
  };

  const handleContinueBrowsing = () => {
    navigate('/marketplace');
  };

  const handleViewLibrary = () => {
    navigate('/account/purchases');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="grow container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <CheckoutLoader isLoading={isLoading} />
          
          {!isLoading && purchase && id ? (
            <PostPurchaseDownloadHandler
              sequenceId={id}
              onDownloadComplete={handleDownloadComplete}
              onError={handleError}
              autoStartDownload={true}
            />
          ) : !isLoading && (
            <CheckoutNotFound />
          )}
        </div>
      </main>
      <Footer />

      {/* Render download flow modals - these are automatically managed by the download flow store */}
      <DownloadFlowAuthModal />
    </div>
  );
};

export default PurchaseSuccess;
